
	import { Component, Prop, Vue } from 'vue-property-decorator';

	@Component
	export default class Modal extends Vue {
		@Prop() private msg!: string;

		private restart() {
			this.$emit('restart');
		}
	}
